/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SharedHotelRateCharge } from "./SharedHotelRateCharge";
import {
  SharedHotelRateChargeFromJSON,
  SharedHotelRateChargeFromJSONTyped,
  SharedHotelRateChargeToJSON,
  SharedHotelRateChargeToJSONTyped,
} from "./SharedHotelRateCharge";
import type { RateType } from "./RateType";
import {
  RateTypeFromJSON,
  RateTypeFromJSONTyped,
  RateTypeToJSON,
  RateTypeToJSONTyped,
} from "./RateType";

/**
 *
 * @export
 * @interface SharedHotelRateSummary
 */
export interface SharedHotelRateSummary {
  /**
   *
   * @type {RateType}
   * @memberof SharedHotelRateSummary
   */
  rateType?: RateType;
  /**
   *
   * @type {string}
   * @memberof SharedHotelRateSummary
   */
  averageNightlyRate?: string;
  /**
   *
   * @type {string}
   * @memberof SharedHotelRateSummary
   */
  total?: string;
  /**
   *
   * @type {string}
   * @memberof SharedHotelRateSummary
   */
  totalRoomBaseRate?: string;
  /**
   *
   * @type {string}
   * @memberof SharedHotelRateSummary
   */
  taxesAndFees?: string;
  /**
   *
   * @type {string}
   * @memberof SharedHotelRateSummary
   */
  propertyFee?: string;
  /**
   *
   * @type {string}
   * @memberof SharedHotelRateSummary
   */
  totalDueAtProperty?: string;
  /**
   *
   * @type {string}
   * @memberof SharedHotelRateSummary
   */
  totalDueToday?: string;
  /**
   *
   * @type {Array<SharedHotelRateCharge>}
   * @memberof SharedHotelRateSummary
   */
  nightlyRoomBaseRates?: Array<SharedHotelRateCharge>;
  /**
   *
   * @type {Array<SharedHotelRateCharge>}
   * @memberof SharedHotelRateSummary
   */
  deposits?: Array<SharedHotelRateCharge>;
  /**
   *
   * @type {Array<SharedHotelRateCharge>}
   * @memberof SharedHotelRateSummary
   */
  chargesDueAtProperty?: Array<SharedHotelRateCharge>;
}

/**
 * Check if a given object implements the SharedHotelRateSummary interface.
 */
export function instanceOfSharedHotelRateSummary(
  value: object
): value is SharedHotelRateSummary {
  return true;
}

export function SharedHotelRateSummaryFromJSON(
  json: any
): SharedHotelRateSummary {
  return SharedHotelRateSummaryFromJSONTyped(json, false);
}

export function SharedHotelRateSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SharedHotelRateSummary {
  if (json == null) {
    return json;
  }
  return {
    rateType:
      json["rate_type"] == null
        ? undefined
        : RateTypeFromJSON(json["rate_type"]),
    averageNightlyRate:
      json["average_nightly_rate"] == null
        ? undefined
        : json["average_nightly_rate"],
    total: json["total"] == null ? undefined : json["total"],
    totalRoomBaseRate:
      json["total_room_base_rate"] == null
        ? undefined
        : json["total_room_base_rate"],
    taxesAndFees:
      json["taxes_and_fees"] == null ? undefined : json["taxes_and_fees"],
    propertyFee:
      json["property_fee"] == null ? undefined : json["property_fee"],
    totalDueAtProperty:
      json["total_due_at_property"] == null
        ? undefined
        : json["total_due_at_property"],
    totalDueToday:
      json["total_due_today"] == null ? undefined : json["total_due_today"],
    nightlyRoomBaseRates:
      json["nightly_room_base_rates"] == null
        ? undefined
        : (json["nightly_room_base_rates"] as Array<any>).map(
            SharedHotelRateChargeFromJSON
          ),
    deposits:
      json["deposits"] == null
        ? undefined
        : (json["deposits"] as Array<any>).map(SharedHotelRateChargeFromJSON),
    chargesDueAtProperty:
      json["charges_due_at_property"] == null
        ? undefined
        : (json["charges_due_at_property"] as Array<any>).map(
            SharedHotelRateChargeFromJSON
          ),
  };
}

export function SharedHotelRateSummaryToJSON(
  json: any
): SharedHotelRateSummary {
  return SharedHotelRateSummaryToJSONTyped(json, false);
}

export function SharedHotelRateSummaryToJSONTyped(
  value?: SharedHotelRateSummary | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    rate_type: RateTypeToJSON(value["rateType"]),
    average_nightly_rate: value["averageNightlyRate"],
    total: value["total"],
    total_room_base_rate: value["totalRoomBaseRate"],
    taxes_and_fees: value["taxesAndFees"],
    property_fee: value["propertyFee"],
    total_due_at_property: value["totalDueAtProperty"],
    total_due_today: value["totalDueToday"],
    nightly_room_base_rates:
      value["nightlyRoomBaseRates"] == null
        ? undefined
        : (value["nightlyRoomBaseRates"] as Array<any>).map(
            SharedHotelRateChargeToJSON
          ),
    deposits:
      value["deposits"] == null
        ? undefined
        : (value["deposits"] as Array<any>).map(SharedHotelRateChargeToJSON),
    charges_due_at_property:
      value["chargesDueAtProperty"] == null
        ? undefined
        : (value["chargesDueAtProperty"] as Array<any>).map(
            SharedHotelRateChargeToJSON
          ),
  };
}
